"use strict";

(function (Drupal) {
  Drupal.behaviors.dartLayout = {
    attach: function attach(context, settings) {
      var layouts = context.querySelectorAll('.layout.layout--twocol');
      if (!layouts.length) {
        return;
      }
      layouts.forEach(function (item) {
        var colFirst = item.querySelector('.layout__region--first .col__content');
        var colSecond = item.querySelector('.layout__region--second .col__content');
        if (!colFirst || !colSecond) {
          return;
        }

        // content volume class logic
        if (colFirst.offsetHeight > colSecond.offsetHeight && colFirst.offsetHeight - colSecond.offsetHeight > 80) {
          item.classList.add('first-is-larger');
        }
        if (colFirst.offsetHeight > colSecond.offsetHeight && colFirst.offsetHeight - colSecond.offsetHeight > 180) {
          item.classList.add('first-is-much-larger');
        }
        if (colFirst.offsetHeight < colSecond.offsetHeight && colSecond.offsetHeight - colFirst.offsetHeight > 80) {
          item.classList.add('second-is-larger');
        }
        if (colFirst.offsetHeight < colSecond.offsetHeight && colSecond.offsetHeight - colFirst.offsetHeight > 180) {
          item.classList.add('second-is-much-larger');
        }

        // content logic
        // checked for mixed elements
        if (colFirst.contains(colFirst.querySelector('img')) && colFirst.contains(colFirst.querySelector('p'))) {
          colFirst.classList.add('is-mixed-elements');
          item.classList.add('first-is-mixed-elements');
        }
        if (colSecond.contains(colSecond.querySelector('img')) && colSecond.contains(colSecond.querySelector('p'))) {
          colSecond.classList.add('is-mixed-elements');
          item.classList.add('second-is-mixed-elements');
        }

        // check for image
        if (colFirst.contains(colFirst.querySelector('img'))) {
          item.classList.add('first-is-image');
        }
        if (colSecond.contains(colSecond.querySelector('img'))) {
          item.classList.add('second-is-image');
        }

        // check if paragraph
        if (colFirst.contains(colFirst.querySelector('p'))) {
          item.classList.add('first-is-text');
        }
        if (colSecond.contains(colSecond.querySelector('p'))) {
          item.classList.add('second-is-text');
        }

        // check for video
        if (colFirst.contains(colFirst.querySelector('iframe'))) {
          item.classList.add('first-is-video');
        }
        if (colSecond.contains(colSecond.querySelector('iframe'))) {
          item.classList.add('second-is-video');
        }
      });
    }
  };
})(Drupal);